<template>
  <div id="app">
    <img src="./assets/icon.png" alt="LeCard" id="imgEmpresa" class="d-none">

    <div v-if="!load">
      <router-view @cancelarDisparo="cancelarDisparo" @buscarDisparos="getDisparos"/>
    </div>

    <loading full="true" :text="errServer" v-else/>

    <div class="modal modal-loading d-block" v-if="loadingGeral" style="z-index: 2090">
      <div class="modal-content border-0">
        <div style="padding: 24px 6px 32px">
          <loading :text="loadingGeral" :ellipsis="true"/>
        </div>
      </div>
    </div>

    <fila-chatbot ref="fila" :empresa="user"/>
  </div>
</template>

<script>
  import Vue from "vue";
  import Loading from "@/components/commons/Loading";
  import FilaChatbot from "@/views/FilaChatbot";

  export default {
    components: {FilaChatbot, Loading},
    name: 'App',
    data() {
      return {
        iniciou: false,
        load: true,
        user: {},
        audio: null,
        errServer: '',
        loadAtend: false,
        disparo: {},
        loadDisparo: false,
        timeoutDisparo: null,
        pesquisa: { keys: [] },
        hasHttpInterceptor: false
      }
    },

    methods: {
      configurarHttpInterceptor() {
        if (this.hasHttpInterceptor) {
          return;
        }

        this.hasHttpInterceptor = true;

        Vue.http.interceptors.push((request, next) => {
          if (this.x_auth) {
            request.headers.set('x-lecard-key', this.x_auth);
          }

          next();
        });
      },

      async autenticar(index, callback) {
        try {
          const result = await this.$store.dispatch('autenticarEmpresa', {
            http: this.$http,
            baseServer: this.base_server,
            index
          });

          if (result && result.success) {
            this.configurarHttpInterceptor();

            if (result.empresa.isDefault || result.statusEmpresa !== '2' || result.habilitarLebot !== '1') {
              if (result.statusEmpresa !== '2') {
                if (this.$route.name !== 'Block') {
                  this.$router.push('/block');
                }

                this.load = false;
                return;
              }

              if (result.habilitarLebot !== '1') {
                if (this.$route.name !== 'Upgrade') {
                  this.$router.push('/upgrade');
                }

                this.load = false;
                return;
              }

              if (['Login'].includes(this.$route.name)) {
                this.$router.push(this.isElectron ? '/home' : '/chamados');
              }
            }

            callback(result.response);
            return;
          }

          if (!(result && result.unauthorized)) {
            this.$swal("Atenção!", "Não conseguimos autenticar sua empresa. Por favor tente novamente!");
            this.load = false;
          }

          callback(false);

        } catch (res) {
          if (!res.status) {
            this.errServer = this.$helpers.verificarServerAlternativo(this.server_alternativo);

          } else {
            this.errServer = "No momento este canal está indisponível.\nPor favor verifique se sua conexão está estável."
          }
        }
      },

      getAtendimentos() {
        if (this.loadAtend) {
          return;
        }

        this.loadAtend = true;

        this.$http.get('chatbot/chamados', { params: this.pesquisa })
          .then(response => {
            this.loadAtend = false;
            const data = response && response.data ? response.data : []

            this.$store.dispatch('setAtendimentosEmpresas', data);

            if (data.length > 0) {
              this.playNotification();
            }

          }, res => {
            this.loadAtend = false;
            this.$swal(res.data.msg || 'Erro temporário');
          });
      },

      getDisparos(id_disparo) {
        if (this.loadDisparo) return;

        console.log('Get disparos');
        this.loadDisparo = true;
        const params = { keys: this.pesquisa.keys, id_disparo: (id_disparo || null) }

        this.$http.get('chatbot/disparar/', { params })
          .then(response => {
            this.loadDisparo = false;

            if (response && response.data) {
              const disparo = response.data;

              if (disparo.id_disparo && disparo.contatos && disparo.contatos.length) {
                disparo.contatos = this.getAmostragem(disparo.contatos, 2000);
                const session = this.wpp_session.find(wpp => wpp.id_empresa === disparo.id_empresa);
                this.dispararMsgs(session, disparo);
              }
            }

          }, res => {
            this.loadDisparo = false;
            this.$swal(res.data.msg || 'Erro temporário');
          });
      },

      dispararMsgs(session, dados) {
        if (session && dados && !this.loadDisparo) {
          this.loadDisparo = true;
          const total = dados.contatos.length;
          const storage = JSON.parse(localStorage.getItem('disparo') || '{}');
          const contatos = (storage.id_disparo === dados.id_disparo) ? storage.contatos : dados.contatos;
          this.salvarDisparos(dados.id_disparo, contatos);
          console.log('Disparos: ' + contatos.length);

          this.alterarDisparo(session.key, dados.id_disparo, 1, () => {
            this.$store.commit('SET_PROGRESS_DISPARO', 1);
            const site = (this.empresas.find(e => e.key === session.key) || {}).site || '';
            this.loopMsg(session, dados, site, contatos, total);
          });
        }
      },

      loopMsg(session, dados, site, contatos, total) {
        if (!contatos.length) {
          this.cancelarDisparo();
          this.alterarDisparo(session.key, dados.id_disparo, 2, () => {
            this.$store.commit('SET_PROGRESS_DISPARO', 0);
            // chama de novo pra ver se nao tem nenhum disparo pendente
            this.getDisparos();
          });

          return;
        }

        const intervalos = [5000, 6000, 7000, 8000, 9000, 10000, 11000, 12000, 13000, 14000, 15000];
        const intervalo = intervalos[Math.floor(Math.random() * intervalos.length)];

        this.timeoutDisparo = setTimeout(() => {
          let nome_user = contatos[0].nome_user ? contatos[0].nome_user.split(' ') : [];
          nome_user = (nome_user && nome_user.length) ? nome_user[0] : "Cliente";
          let content = dados.content.replaceAll('{nome_cliente}', nome_user).replaceAll('{link}', site);
          let mensagens = [{ content }];

          if (dados.imagem) {
            mensagens = [{content: dados.imagem, caption: content, type: 'image'}];
          }

          window.control.dispararMensagens({ to: '55' + contatos[0].telefone, mensagens, wpp: session.wpp });
          console.log({ to: '55' + contatos[0].telefone, intervalo });
          contatos.splice(0, 1);

          // total disparado
          this.$store.commit('SET_PROGRESS_DISPARO', (((total - contatos.length) / total) * 100).toFixed());
          this.salvarDisparos(dados.id_disparo, contatos);
          this.loopMsg(session, dados, site, contatos, total);
        }, intervalo);
      },

      cancelarDisparo() {
        console.log('Disparo finalizado');
        clearTimeout(this.timeoutDisparo);
        this.disparo = {};
        localStorage.removeItem('disparo');
        this.loadDisparo = false;
      },

      alterarDisparo(token, id_disparo, status, callback) {
        if (id_disparo) {
          this.$http.post('chatbot/disparos/status/' + token, { id_disparo, status }).then(res => {
            this.load = false;

            if (callback) {
              callback();
            }

          }, res => {
            this.load = false;
            this.$swal(res.data.msg ? res.data.msg : 'Erro temporário');
          });
        }
      },

      salvarDisparos(id_disparo, contatos) {
        this.disparo = { id_disparo, contatos };
        localStorage.setItem('disparo', JSON.stringify(this.disparo));
      },

      getAmostragem(array, sampleSize) {
        if (sampleSize >= array.length) {
          return array;
        }

        for (let i = 0; i < sampleSize; i++) {
          const j = i + Math.floor(Math.random() * (array.length - i));
          [array[i], array[j]] = [array[j], array[i]];
        }

        return array.slice(0, sampleSize);
      },

      playNotification() {
        if (this.canPlay && this.audio && this.audio.paused) {
          this.audio.play();
        }
      },

      requestHuman(data) {
        if (!this.audio) {
          this.audio = new Audio("https://lecard-cdn.nyc3.cdn.digitaloceanspaces.com/lecard-gestor/lebot-bell.mp3");
        }

        new Notification('Solicitação de atendimento!', {
          body: 'Nova solicitação de atendimento',
          icon: document.getElementById('imgEmpresa').src
        });

        if (data && data.telefone) {
          setTimeout(() => {
            const session = this.wpp_session.find(w => w.token === data.token);

            if (session) {
              window.control.markUnread({ phone: `55${data.telefone}@c.us`, wpp: session.wpp });
              this.getDisparos();
              this.$refs.fila.getFila(session);
            }
          }, 15000);
        }

        this.getAtendimentos();
      },

      autenticarEmpresas(count) {
        if (count < this.empresas.length) {
          this.autenticar(count, () => {
            this.autenticarEmpresas(++count);
          })

        } else if (this.empresas.length) {
          this.$store.dispatch('finalizeEmpresas');
          this.pesquisa.keys = this.empresas.map(e => { return e.key });

          if (this.isElectron) {
            this.$store.commit('SET_CAN_PLAY', true);
            window.control.getAppVersion().then(version => {
              this.$store.commit('SET_VERSION', version);
              const appVersion = parseInt(version.replace(/[^0-9]/g, ''));
              const hasUpdate = this.hasUpdate(appVersion, this.empresas[0].id_empresa);

              if (hasUpdate) {
                this.$router.push('/versao');
                this.load = false;

              } else {
                this.getAtendimentos();

                window.control.login({
                  empresas: this.empresas,
                  base_server: this.base_server,
                  connect_version: this.connect_version,
                  wpp_version: this.wpp_version,
                  lebot_api: 3232 // apenas para compatibilidade / remover depois / v163
                });
              }
            });

          } else {
            this.$swal({
              text: 'Ação necessária para ativar o som das notificações',
              button: "Inicializar agora"
            }).then((r) => {
              this.$store.commit('SET_CAN_PLAY', true);
              this.getAtendimentos();
            });
          }

          this.empresas.forEach(e => { this.$socket.emit('empresa_connected', e.token)});
          this.$store.dispatch('restoreWppSessions');

          this.load = false;

        } else {
          this.logout();
        }
      },

      hasUpdate(appVersion, id_empresa) {
        if (this.versao_atual > appVersion) {
          return true;
        }

        // Rollout parcial
        if (this.last_versao > appVersion && id_empresa) {
          return Number(id_empresa) % 2 === 0; // só 50%
        }

        return false;
      },

      iniciar() {
        this.$store.dispatch('hydrateEmpresas', {
          parseJSONObject: this.$helpers.parseJSONObject
        });

        if (this.empresas && this.empresas.length) {
          this.errServer = "Autenticando..";
          this.autenticarEmpresas(0);

        } else {
          localStorage.removeItem('key');
          localStorage.removeItem('token');

          if (!['Login','RecuperarSenha'].includes(this.$route.name)) {
            this.$router.push('/');
          }

          setTimeout(() => {
            this.load = false;
          }, 1000);
        }
      }
    },

    mounted() {
      this.iniciar();

      if (!this.audio) {
        this.audio = new Audio("https://lecard-cdn.nyc3.cdn.digitaloceanspaces.com/lecard-gestor/lebot-bell.mp3");
      }
    },

    created() {
      // Usar pra testar no navegador o Bot
      // document.dispatchEvent(new CustomEvent('wpp_session', { detail: {phone: '5516993626508',key: 'a4168c87dd0e85065d7b371e31481e96',token: 'hhhtatululuwjbaw3ron5psf2qr3',wpp: null,id_empresa: '2',bandeiras: null}}));

      setTimeout(() => {
        this.$store.commit('SET_IS_READY', true);
      }, 10000);

      if (this.isElectron) {
        window.control.onErrorReply((data) => {
          if (data) {
            this.$swal(data);
          }
        });

        window.control.onWppSession((data) => {
          this.$store.dispatch('addWppSession', data);

          setTimeout(() => {
            this.$refs.fila.loopFila();
          }, 15000);
        });

        window.control.onLebotStatus((data) => {
          this.$store.commit('SET_CONFIG', data);
        });

        window.control.onRequestHuman(() => {
          this.requestHuman();
        });

        window.control.onUpdateReply((data) => {
          this.$store.commit('SET_UPDATE_REPLY', data);
        });

        window.control.onUpdateProgress((data) => {
          this.$store.commit('SET_UPDATE_PROGRESS', data);
        });
      }
    },

    sockets: {
      connect() {
        if (this.empresas && this.isReady) {
          console.log('empresa_connected')
          this.empresas.forEach(e => { this.$socket.emit('empresa_connected', e.token)});
        }
      },

      request_human(data) {
        this.requestHuman(data);
      },

      delivery_whatsapp(token) {
        const session = token ? this.wpp_session.find(w => w.token === token) : null;

        if (session) {
          this.$refs.fila.getFila(session);
        }
      },

      trigger_bot(data) {
        const session = data?.token ? this.wpp_session.find(w => w.token === data.token) : null;

        if (session) {
          this.getDisparos(data.id_disparo);
        }
      }
    },

    computed: {
      loadingGeral() {
        return this.$store.state.load;
      },

      wpp_session() {
        return this.$store.state.wpp_session
      },

      empresas() {
        return this.$store.state.empresas
      },

      x_auth() {
        return ((this.empresas.find((empresa) => empresa.isDefault) || {}).x_auth) || ''
      },

      canPlay() {
        return this.$store.state.canPlay
      },

      isReady() {
        return this.$store.state.isReady
      }
    },

    destroyed() {
      console.log('clear');
      clearTimeout(this.timeoutDisparo);
    }
  }
</script>
